export default __webpack_public_path__ + "locales/sk/SharingPanel.json?hash=f658459784b23ad82caf3e9446097ff0";